import React, { useEffect } from 'react'
import constant from '../../constant'
import { useGlobalData } from '../../context/GlobalDataContext';

const Layout = ({ children }) => {
    useEffect(() => {
        document.body.classList.add('bg-cover-center');
    }, [])
    const { globalData } = useGlobalData();

    return (
        <React.Fragment>

            <div className="account-pages pt-sm-5 ">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card overflow-hidden">
                                <div
                                    className=""
                                    style={{ backgroundColor: 'rgba(204, 202, 202, 0.5)' }}

                                >
                                    <div className="row">
                                        <div className="col-8">
                                            <div className="text-primary p-4">
                                                <a
                                                    href="/"
                                                    className=""
                                                    style={{ color: "#009dac", fontFamily: '"Oswald"', fontSize: 22 }}
                                                >
                                                   {globalData?.COMPANY_NAME}
                                                </a>
                                                <h5
                                                    className=""
                                                    style={{
                                                        fontFamily: "oswald",
                                                        color: "#010101",
                                                        fontSize: 16
                                                    }}
                                                >
                                                    NEW-BUILDING SHIP SITE MANAGEMENT
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="col-4 align-self-end">
                                            <img src="assets/images/profile-img.png" alt="" className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body pt-0">
                                    <div className="auth-logo">
                                        <a href="index.php" className="auth-logo-light">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src="img/imgbin_boat-computer-icons-ship-yacht-png.png"
                                                        alt=""
                                                        className="rounded-circle"
                                                        height={70}
                                                    />
                                                </span>
                                            </div>
                                        </a>
                                        <a href="index.php" className="auth-logo-dark">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src="img/imgbin_boat-computer-icons-ship-yacht-png.png"
                                                        alt=""
                                                        className="rounded-circle"
                                                        height={70}
                                                    />
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="p-2">
                                        {children}
                                    </div>
                                </div>
                            </div>

                            
                            <div className="text-center">

                                <div>
                                    <p>
                                        {/* <a href="https://ishipplus.com/" target="_blank">
                                            <img
                                                src={`${process.env.REACT_APP_BASE_URL}/v1/globalSettings/${globalData?.COMPANY_LOGO}`}
                                                style={{
                                                    width: 150,
                                                    marginBottom: 12,
                                                    boxShadow: "-1px -1px 13px #3d3c3c",
                                                    background: "#ffffff",
                                                    padding: 5,
                                                    borderRadius: 5
                                                }}
                                            />
                                        </a>
                                        <br />
                                        <br /> */}
                                        <span style={{ background: "rgb(255 255 255 / 70%)", padding: 5 }}>
                                            Crafted with <i className="bx bx-heart" style={{ color: "red" }} /> by{" "}
                                            <a
                                                href="javascript:void(0);"
                                                title={globalData?.COMPANY_NAME}
                                                style={{ color: "#006ccf" }}
                                            >
                                                {globalData?.COMPANY_NAME}
                                            </a>
                                        </span>


                                    </p>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </React.Fragment>
    )
}

export default Layout